import React, { useContext, useEffect, useState } from "react";
import { TemplateContext } from "../../layout";
import { AmericanFlagIcon, BenefitCheck } from "../../utils/miscIcons";
import Bars from "../Bars";
import HeroSellingPoints from "./HeroSellingPoints";
import RatingLine from "./RatingLine";
import SocialMediaBanner from "./SocialMediaBanner";
import SwiperGallery from "./SwiperGallery.jsx";

const ProductHeroSection = ({ isMobile }) => {
  const [templateContext, setTemplateContext] = useContext(TemplateContext);
  const [galleryRow, setGalleryRow] = useState("grid-row-2");
  const [flagRow, setFlagRow] = useState("grid-row-3");
  const [barsRow, setBarsRow] = useState("grid-row-1");
  const heroContent = window.post_template.checkout_v4_product_hero;
  const mobileHeroVariant = heroContent?.checkout_v4_product_hero_variant;
  const flagIcon = heroContent.checkout_v4_product_hero_flagIcon;
  const backgroundColor = heroContent.checkout_v4_product_hero_background;
  const checkMarkFill = heroContent.checkout_v4_product_hero_checklistColor;
  const galleryBorderColor = heroContent.checkout_v4_product_hero_galleryBorder;
  const textColorPrimary = heroContent.checkout_v4_product_hero_textPrimary;
  const textColorFlag = heroContent.checkout_v4_product_hero_textFlag;
  const textColorSecondary = heroContent.checkout_v4_product_hero_textSecondary;
  const borderColor = heroContent?.checkout_v4_product_hero_socialsBorderColor;

  document.documentElement.style.setProperty("--gallery-border-color", galleryBorderColor);
  document.documentElement.style.setProperty("--hero-text-primary", textColorPrimary);
  document.documentElement.style.setProperty("--hero-text-flag", textColorFlag);
  document.documentElement.style.setProperty("--hero-text-secondary", textColorSecondary);

  const benefitsData = heroContent.checkout_v4_product_hero_benefits.map(
    (item) => item.tr_checkout_v4_product_herobenefit_title
  );

  const CreateBenefits = () => {
    return benefitsData.map((benefit, index) => (
      <li key={index} className="productHero__benefits__item">
        <BenefitCheck fill={checkMarkFill} /> {benefit}
      </li>
    ));
  };

  useEffect(() => {
    if (mobileHeroVariant == "twoBars" || mobileHeroVariant == "oneBar") {
      setGalleryRow("grid-row-6");
    } else if (mobileHeroVariant == "flag") {
      setGalleryRow("grid-row-6");
    }
    if (mobileHeroVariant == "twoBars" || mobileHeroVariant == "oneBar") {
      setFlagRow("grid-row-2");
    } else if (mobileHeroVariant == "flag") {
      setFlagRow("grid-row-1");
    } else {
      setFlagRow("grid-row-3");
    }
    mobileHeroVariant == "flag" ? setBarsRow("grid-row-5") : setBarsRow("grid-row-1");
  }, []);

  return (
    <>
      <div className="productHero__wrapper" style={{ background: backgroundColor, borderColor: borderColor }}>
        <div className="productHero__container">
          <div className={barsRow}>
            <Bars mobile={true} />
          </div>
          <div className={`productHero__galleryWrapper ${galleryRow}`}>
            {/*<Gallery isMobile={isMobile} />*/}
            <SwiperGallery heroContent={window.post_template.checkout_v4_product_hero} />
          </div>
          {!templateContext.complianceMode && (
            <div className={`productHero__specialOffer hero-grid-column-2 ${flagRow}`}>
              {flagIcon ? (
                <img className="productHero__flagIcon" src={flagIcon} alt={general_settings.brand_name}></img>
              ) : (
                <AmericanFlagIcon />
              )}
              <span>{heroContent.tr_checkout_v4_flag_text}</span>
            </div>
          )}
          <div className="hero-grid-column-2">{!templateContext.complianceMode && <RatingLine />}</div>
          <div className="productHero__heading hero-grid-column-2">{heroContent.tr_checkout_v4_product_hero_title}</div>
          <div className="productHero__description ProductHeroSection hero-grid-column-2">
            {heroContent.tr_checkout_v4_product_hero_description}
          </div>
          {benefitsData && (
            <ul className="productHero__benefits hero-grid-column-2" style={{ listStyleType: "none" }}>
              {CreateBenefits()}
            </ul>
          )}
          <div className="hero-grid-column-2">{!templateContext.complianceMode && <SocialMediaBanner />}</div>
          <div className="hero-grid-column-2 hero-selling-points-tablet">
            <HeroSellingPoints />
          </div>
        </div>
      </div>
      <div className="productHero__bottomLine"></div>
    </>
  );
};

export default ProductHeroSection;
